__turbopack_context__.v({
  "animate": "styles-module-scss-module__41M6Aq__animate",
  "opacity": "styles-module-scss-module__41M6Aq__opacity",
});
